<template>
    <div id="incomplete-answers-queue-container">
        <card title="Incomplete Answers">
            <div>
                <b-row>
                    <b-col>
                        <SearchComponent v-model="categoryFilter" search-u-r-l="/DrugCategory" :clearable="true"
                            :prepopulate="true" />
                    </b-col>
                </b-row>
                <b-button variant="info" @click="search">
                    Search
                </b-button>
            </div>
            <PrescriptionsListComponent :prescriptions="prescriptions" :showSelectCheckox="false"
                :actionButtons="['edit']" mode="IncompleteAnswers" />
        </card>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator';
import Axios, { AxiosResponse } from 'axios';
import { NotificationOptions } from "@/util/NotificationOptionsPresets"

import Card from '@/components/Cards/Card.vue';
import SearchComponent from '@/components/SearchComponent.vue';
import PrescriptionsListComponent, { PrescriptionListColumn } from '@/components/Prescription/PrescriptionsListComponent.vue';

import { Prescription } from '@/models/Prescription';
import { DrugCategory } from '@/models/DrugCategory';

@Component({
    name: "IncompleteAnswersQueuePage",
    components: {
        SearchComponent,
        PrescriptionsListComponent
    },
})
export default class IncompleteAnswersQueuePage extends Vue {
    private prescriptions: Array<Prescription> = [];
    private categoryFilter: DrugCategory = new DrugCategory();

    created() {
        this.load();
    }

    async load() {
        try {
            const response = await Axios.get(`/api/Prescription/list-rx-incomplete-answers/${(this.categoryFilter?.id || '')}`);
            this.prescriptions = response.data;
        } catch (error) {
            console.error("Error while loading Rxs with incomplete answers", error);
            this.$notification(NotificationOptions.error(error));
        }
    }

    search() {
        this.load();
    }
}

</script>
